<template>
    <div class="search pb-8">
      <div class="pageCent ma-auto">
        <div class="top">
          <div class="tj1 d-flex">
            <div class="tj1-left">品牌：</div>
            <div class="tj1-right">
              <ul>
                <li :class="{ act: query.ssuBrandIds === undefined }" @click="pingPai('')">全部</li>
                <li :class="{ act: query.ssuBrandIds === item.id }" v-for="(item, index) in brands" :key="index" @click="pingPai(item.id)">{{ item.name }}</li>
              </ul>
            </div>
          </div>
          <div class="tj2">
            <button class="btnn" @click="jiage" type="button">
              价格
              <i :class="{ act: btn === 1 }" class="mdi mdi-chevron-up"></i>
              <i :class="{ act: btn === 2 }" class="mdi mdi-chevron-down"></i>
            </button>
          </div>
        </div>

        <goods-list :initData="initData"></goods-list>

        <div class="text-center pb-8" v-if="initData && initData.length">
          <v-pagination
            v-model="query.pageNum"
            :length="total"
            @input="inputFun"
            @next="nextFun"
            @previous="prevFun"
          ></v-pagination>
        </div>
      </div>
    </div>
</template>

<script>
import { productSearchList } from '../../api/goods'
import goodsList from '../../components/goodsList'
export default {
  name: 'SearchList',
  components: {
    goodsList
  },
  data () {
    return {
      btn: 0,
      query: {
        pageNum: 1,
        keyWords: '',
        sortWord: 'ssuId',
        sortType: undefined,
        ssuBrandIds: undefined
      },
      brands: [],
      initData: [],
      total: 0
    }
  },
  created () {
    this.query.keyWords = this.$route.query.search || ''
    this.getData()
  },
  methods: {
    jiage () {
      this.btn = this.btn++ >= 2 ? 0 : this.btn++
      this.query.sortType = this.btn === 1 ? 'asc' : this.btn === 2 ? 'desc' : undefined
      this.query.sortWord = this.btn === 1 ? 'ssuSellingPrice' : this.btn === 2 ? 'ssuSellingPrice' : 'ssuId'
      this.getData()
    },
    inputFun (val) {
      this.query.pageNum = val
      this.getData()
    },
    nextFun (val) {
      this.query.pageNum = val
      this.getData()
    },
    prevFun (val) {
      this.query.pageNum = val
      this.getData()
    },
    pingPai (id) {
      this.query.ssuBrandIds = id || undefined
      this.getData()
    },
    getData () {
      productSearchList(this.query).then(res => {
        if (res.data.success) {
          if (!(this.brands && this.brands.length)) {
            this.brands = res.data.data.brands
          }
          this.initData = res.data.data.pageInfo.list
          this.total = Math.ceil(res.data.data.pageInfo.total / 10)
        } else {
          this.$toastMsg(res.data.message, {
            color: '#ff5252'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .search{
    background-color: #F2F2F2;
  }
  .pageCent{
    width: 1200px;
    .top{
      background-color: #ffffff;
      .tj1{
        .tj1-left{
          width: 116px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #333333;
          text-align: center;
          font-weight: bold;
        }
        .tj1-right{
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          ul{
            padding: 0;
            list-style: none;
            li{
              float: left;
              margin: 0 20px;
              cursor: pointer;
              &.act{
                color: #2196F3;
              }
              &:hover{
                color: #2196F3;
              }
            }
          }
        }
      }
      .tj2{
        border-top: 1px solid #F2F2F2;
        padding: 15px 10px;
        .btnn{
          width: 128px;
          height: 35px;
          border: 1px solid #CCCCCC;
          border-radius: 4px;
          position: relative;
          padding-right: 20px;
          font-size: 14px;
          outline: none;
          .mdi{position: absolute; right: 10px; color: #CCCCCC;}
          .mdi.act{
            color: #333333;
          }
          .mdi-chevron-up{top: 2px;}
          .mdi-chevron-down{bottom: 2px;}
        }
      }
    }
  }
</style>
